import React from "react";
import { scrollToApply } from "./anchors";
import Arrow from "./Arrow";
import { Wrapper, Card } from "./UseCases.styles";

export type UseCase = {
  /** category chip overlaid on the image */
  pill: string;
  /** bold lead-in line */
  title: string;
  text: string;
  image: string;
  alt: string;
};

const UseCases = ({ useCases }: { useCases: UseCase[] }) => {
  return (
    <Wrapper className="section-lp-usecases">
      <div className="inner">
        <div className="head">
          <p className="eyebrow">What people use Patria for</p>
          <h2 className="heading">
            Built for the moments that{" "}
            <span className="marked">
              <span>can&apos;t wait.</span>
            </span>
          </h2>
        </div>

        <div className="cards">
          {useCases.map(({ pill, title, text, image, alt }) => (
            <Card className="lp-card" key={pill}>
              <div className="media">
                <img src={image} alt={alt} loading="lazy" />
                <span className="pill">{pill}</span>
              </div>
              <div className="body">
                <h3 className="title">{title}</h3>
                <p className="text">{text}</p>
                <button type="button" className="link" onClick={scrollToApply}>
                  See if you qualify <Arrow />
                </button>
              </div>
            </Card>
          ))}
        </div>
      </div>
    </Wrapper>
  );
};

export default UseCases;
